import Link from 'antd/es/typography/Link';
import React from 'react';
import { EMAILS, ONBOARDING_NO_PERMISSION_COPY, URLS } from '@sonar-software/sonar-ts-constants';
export const MissingPermissionMessage = () => React.createElement("p", null,
    ONBOARDING_NO_PERMISSION_COPY.AROVY_UNABLE_TO_CONNECT,
    React.createElement("br", null),
    React.createElement("br", null),
    ONBOARDING_NO_PERMISSION_COPY.PARTIAL_INFORMATION,
    React.createElement(Link, { href: ONBOARDING_NO_PERMISSION_COPY.PARTIAL_ZENDESK_LINK, target: 'blank' }, ONBOARDING_NO_PERMISSION_COPY.PARTIAL_HERE),
    ONBOARDING_NO_PERMISSION_COPY.PARTIAL_PERIOD,
    React.createElement("br", null),
    React.createElement("br", null),
    ONBOARDING_NO_PERMISSION_COPY.PARTIAL_CONTACT_US,
    React.createElement("a", { href: URLS.SUPPORT_EMAIL, rel: 'noopener', target: '_blank' }, EMAILS.SUPPORT),
    ONBOARDING_NO_PERMISSION_COPY.PARTIAL_PERIOD);
